// extracted by mini-css-extract-plugin
module.exports = {"doughnutWrapper":"SuggestionDoughnut_doughnutWrapper__owu_Y","doughnutCount":"SuggestionDoughnut_doughnutCount__3kZeq","withoutLabel":"SuggestionDoughnut_withoutLabel__1YXfO"};